// extracted by mini-css-extract-plugin
module.exports = {"tokens":"opsampTokens_tokens__R0J5N"};